import module from 'finanzas/module.js'
import template from './template.html'

module.config(($dialogProvider) => {
  $dialogProvider.dialog('finanzas.detallesFacturacion.detalle.facturas.factura', {
    controller: 'FinanzasDetallesFacturacionDetalleFacturasFacturaController',
    template,
    controllerAs: '$ctrl',
  })
})

var IVA = 0.16
var Empleados_cache = {}

function FinanzasDetallesFacturacionDetalleFacturasFacturaController ($dialogParams, $catalogos, $kardex, dialog, $scope) {
  var $ctrl = this
  $ctrl.view = 1
  $ctrl.loading = false

  $ctrl.payment = $dialogParams['invoice'] || {
    Factura: undefined,
    Pago_ID_Empresa: undefined,
    Pago_ID_Empleado: undefined,
    Factura_ID_Empresa: undefined,
    Factura_ID_Empleado: undefined,
    Banco_ID: undefined,
    Banco_Numero_Cuenta: undefined,
    Subtotal: undefined,
    IVA: null,
    Comision: null,
    Comision_Porcentaje: undefined,
    Total: 0,
  }

  $ctrl.catalogos = {
    Empleados: Empleados_cache,
    Bancos: undefined,
    Bancos_Cuentas: undefined,
    Empresas: undefined,
  }

  $catalogos.$fetch().then(function (catalogos) {
    $ctrl.catalogos.Bancos = catalogos.Bancos.$select()
    $ctrl.catalogos.Bancos_Cuentas = catalogos.Bancos_Cuentas.$select()
    $ctrl.catalogos.Empresas = catalogos.Empresas.$select()
  })

  $ctrl.$fetch = function (company) {
    if (company && !$ctrl.catalogos.Empleados[company]) {
      $ctrl.loading = true
      $kardex.$list(company).then(function (kardexes) {
        $ctrl.catalogos.Empleados[company] = kardexes
      }).finally(function () {
        $ctrl.loading = false
      })
    }
  }

  $ctrl.$calculate = function () {
    if (!$ctrl.payment.Comision_Porcentaje || !$ctrl.payment.Subtotal) {
      return
    }
    $ctrl.payment.Comision = parseFloat((Number($ctrl.payment.Comision_Porcentaje) * $ctrl.payment.Subtotal).toFixed(2))
    $ctrl.payment.IVA = parseFloat((($ctrl.payment.Subtotal + $ctrl.payment.Comision) * IVA).toFixed(2))
    $ctrl.payment.Subtotal = parseFloat($ctrl.payment.Subtotal)
    $ctrl.payment.Total = parseFloat(($ctrl.payment.Subtotal + $ctrl.payment.IVA + $ctrl.payment.Comision).toFixed(2))
  }

  $ctrl.$cancel = function () {
    dialog.reject()
  }

  $ctrl.$select = function () {
    dialog.resolve($ctrl.payment)
  }

  $scope.$watch('$ctrl.payment.Pago_ID_Empresa', $ctrl.$fetch)
  $scope.$watch('$ctrl.payment.Factura_ID_Empresa', $ctrl.$fetch)
}

module.controller('FinanzasDetallesFacturacionDetalleFacturasFacturaController', FinanzasDetallesFacturacionDetalleFacturasFacturaController)



// WEBPACK FOOTER //
// ./src/finanzas/_/detallesFacturacion/detalle/facturas/factura/controller.js